(function () {
  'use strict'

  /**
     * @ngdoc service
     * @name UgcApi
     * @module thismoment.glow.component.module-ugc.provider.ugc-api
     *
     * @description
     * Allows the glow page and glow modules to access the user input
     */

  var MODULE_NAME = 'thismoment.glow.component.module-ugc.provider.ugc-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../../../../api/async')
    ])
    .provider('UgcApi', ugcApiProvider)

  function ugcApiProvider () {
    return {
      $get: ugcApiService
    }
  }

  ugcApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function ugcApiService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/solution/v1/glow/ugc-submit')

    return {
      send: sendUgc
    }

    function sendUgc (data, moduleId, playlistId) {
      var postBody = {
        account_id: SdkConfig.get('account_id'),
        group_id: SdkConfig.get('group_id'),
        glow_id: SdkConfig.get('solution_id'),
        module_id: moduleId,
        playlist_id: playlistId,
        data: data
      }

      return API.post({}, postBody)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-ugc/provider/ugc-api.js